import { styled } from '@linaria/react';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
  width: 100%;
`;

export const Field = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[3]};
  min-height: 64px;
  padding: ${space[2]} ${space[2]} ${space[2]} ${space[5]};
  border: 1px solid ${semantic.border.default};
  border-radius: ${layout.borderRadiusLg};
  background: ${colors.white};
  box-sizing: border-box;
  transition: border-color 120ms ease;

  &:focus-within {
    border-color: ${colors.primary};
  }

  &[data-error='true'] {
    border-color: ${semantic.border.danger};
  }

  &[data-disabled='true'] {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const FieldStack = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
`;

export const InlineLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  font-weight: ${fonts.weight.normal};
  line-height: 1.4;
  color: ${semantic.text.secondary};
`;

export const Input = styled.input`
  border: none;
  background: transparent;
  outline: none;
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  line-height: 1.4;
  color: ${semantic.text.primary};
  padding: 0;
  width: 100%;

  &::placeholder {
    color: ${semantic.text.tertiary};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const ApplyButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 0 ${space[5]};
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  line-height: 1.4;
  color: ${semantic.text.tertiary};
  background: ${semantic.bg.surfaceSubtle};
  border: none;
  border-radius: ${layout.borderRadiusFull};
  cursor: pointer;
  white-space: nowrap;
  transition: color 120ms ease, background 120ms ease;

  &[data-active='true'] {
    color: ${colors.white};
    background: ${colors.primary};
  }

  &[data-active='true']:hover {
    opacity: 0.85;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const ErrorRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[2]};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.danger};
`;

export const AppliedList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
`;

export const SuccessRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${space[2]};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  line-height: 1.4;
  color: ${semantic.text.primary};
`;

export const SuccessCheck = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: ${semantic.text.positive};
`;

export const AppliedCard = styled.div`
  display: flex;
  align-items: center;
  gap: ${space[3]};
  padding: ${space[3]} ${space[4]};
  border-radius: ${layout.borderRadiusLg};
  background: ${semantic.bg.surfaceSubtle};
  box-sizing: border-box;
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  line-height: 1.4;
`;

export const AppliedBody = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${space[1]};
`;

export const AppliedCode = styled.span`
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AppliedAmount = styled.span`
  flex-shrink: 0;
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.positive};
`;

export const AppliedDescription = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  line-height: 1.4;
  color: ${semantic.text.secondary};
`;

export const RemoveIconButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  border-radius: ${layout.borderRadiusFull};
  background: transparent;
  color: ${semantic.text.secondary};
  cursor: pointer;
  transition: color 120ms ease;

  &:hover {
    color: ${semantic.text.primary};
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;
